const $header = $('.header');
const $headerNavigations = $('.header__navigations');
const activeClass = 'is-active';
const $win = $(window);

//Nav trigger actions
$('.js-nav-trigger').on('click', function(e) {
	e.preventDefault();

	$(this).closest($header)
		.find($headerNavigations)
		.addClass(activeClass)
})

//Nav close actions
$('.js-nav-close').on('click', function(e) {
	e.preventDefault();

	$(this).closest($header)
		.find($headerNavigations)
		.removeClass(activeClass)
})

$win.on('load resize', function() {
	if ($win.width() > 767) {
		$headerNavigations.removeClass(activeClass)
	}
})

